<template>
  <div class="action-element-buttons-block">
    <el-popconfirm
      v-if="$canAndRulesPass(scope.row, $permissions.CARD_ELEMENT.DELETE)"
      confirm-button-text='Да'
      cancel-button-text='нет'
      icon="fas fa-question"
      title="Вы уверены, что хотите удалить элемент?"
      @confirm="deleteElement(scope.row)"
    >
      <el-button
        slot="reference"
        class="table-action-button"
        round
        size="mini"
        icon="far fa-trash-alt"
        :loading="loading"
      >
      </el-button>
    </el-popconfirm>
    <el-popover
      v-if="scope.row.is_reset_weight"
      placement="top"
      width="200"
      trigger="hover"
    >
      <el-button
        slot="reference"
        class="table-action-button danger"
        type="text"
        round
        size="mini"
        icon="fas fa-info-circle"
      ></el-button>
      <span>Данная цель обнулена</span>
    </el-popover>
    <el-popconfirm
      v-else-if="$canAndRulesPass(scope.row, 'card_element.weight_reset') && scope.row.weight > 0"
      confirm-button-text='Да'
      cancel-button-text='нет'
      icon="fas fa-question"
      title="Вы уверены, что хотите обнулить цель? Вес данной цели равномерно распределится между оставшимися целями."
      @confirm="resetWeightElement(scope.row)"
    >
      <el-button
        title="Обнулить цель"
        slot="reference"
        class="table-action-button"
        round
        size="mini"
        icon="fas fa-balance-scale"
        :loading="loading"
      >
      </el-button>
    </el-popconfirm>
  </div>
</template>

<script>
import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import requestSender from "@/api/base/requestSender";

export default {
  name: 'element-actions-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],
  props: {
    scope: {type: Object, required: true},
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    deleteElement(element) {
      this.loading = true;
      this.$api.card.deleteElement({
        id: element.id,
      })
        .then((data) => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Элемент успешно удален'
          });
        })
        .finally(() => {
          this.loading = false;
          this.$emit('elements-changed');
        })
    },
    resetWeightElement(element) {
      this.loading = true;
      requestSender('post', 'card/reset-weight-element',{
        id: element.id,
      })
        .then((data) => {
          if (data.success) {
            this.$store.dispatch('card/sections/loadSections');

            this.$notify.success({
              title: 'Цель обнулена',
              message: 'Цель успешно обнулена'
            });
          } else {
            this.$notify.error({
              title: 'Отклонено',
              message: 'Нет других целей в карте для распределения веса'
            });
          }
        })
        .finally(() => {
          this.loading = false;
        })
    },
  }
}
</script>

<style>
  .action-element-buttons-block {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
  }
</style>
